// @flow
import * as React from 'react';
import loadStripe from 'utils/loadStripe';

type Props = {
  render: boolean => React.Node
};

type State = {
  loading: boolean
};

class StripeLoader extends React.Component<Props, State> {
  state = {
    loading: true
  };

  componentDidMount() {
    loadStripe().then(() => {
      this.setState({ loading: false });
    });
  }

  render() {
    return this.props.render(this.state.loading);
  }
}

export default StripeLoader;
